module.exports = __webpack_public_path__ + "img/联系我们图片.255cdff3.png";